import React from 'react'
import { Backdrop, CircularProgress, Typography } from '@mui/material'

interface LoadingBackdropProps {
  isOpen: boolean
  message?: string
}

const LoadingBackdrop: React.FC<LoadingBackdropProps> = ({
  isOpen,
  message
}) => {
  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: theme => theme.zIndex.modal + 100,
        flexDirection: 'column',
        display: 'flex'
      }}
      open={isOpen}
    >
      <CircularProgress color='inherit' />
      {message && (
        <Typography variant='body1' mt={2}>
          {message}
        </Typography>
      )}
    </Backdrop>
  )
}

export default LoadingBackdrop
